import React from 'react'

const Skills = () => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
            <div className="skills-list">
                <div className="skill-title border-line-h">
                    <div className="icon"><i className="fa fa-paint-brush"></i></div>
                    <div className="name">Design</div>
                </div>
                <ul>
                    <li className="border-line-h">
                        <div className="name">Front-End Development</div>
                        <div className="progress">
                            <div className="percentage p60" ></div>
                        </div>
                    </li>
                    <li className="border-line-h">
                        <div className="name">Back-End Development</div>
                        <div className="progress">
                            <div className="percentage p80"></div>
                        </div>
                    </li>
                    <li className="border-line-h">
                        <div className="name">Cloud Software Engineering</div>
                        <div className="progress">
                            <div className="percentage p40"></div>
                        </div>
                    </li>
                    <li>
                        <div className="name">Devops</div>
                        <div className="progress">
                            <div className="percentage p40" ></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Skills;